import {Layout, Anchor, Typography} from 'antd';
import React, {useState} from 'react';
import appColors from '../../style/theme';
import Uno from './BusinessPages/Uno';
import Dos from './BusinessPages/Dos';
import Tres from './BusinessPages/Tres';
import Cuatro from './BusinessPages/Cuatro';
import Cinco from './BusinessPages/Cinco';
import Seis from './BusinessPages/Seis';
import Siete from './BusinessPages/Siete';
import Ocho from './BusinessPages/Ocho';
import Nueve from './BusinessPages/Nueve';
import Diez from './BusinessPages/Diez';
import References from './BusinessPages/References';

const {Link} = Anchor;
const {Sider, Content} = Layout;
const Text = Typography;


const handleClick = (e, link) => {
  e.preventDefault();
  console.log(link);
};

const EntrepreneurshipBM = () => {
  const [backI, setBackI] = useState('transparent');
  const [backII, setBackII] = useState('transparent');
  const [backIII, setBackIII] = useState('transparent');
  const [backIV, setBackIV] = useState('transparent');
  const [backV, setBackV] = useState('transparent');
  const [backVI, setBackVI] = useState('transparent');
  const [backVII, setBackVII] = useState('transparent');
  const [backVIII, setBackVIII] = useState('transparent');
  const [backIX, setBackIX] = useState('transparent');
  const [backX, setBackX] = useState('transparent');
  const [backXI, setBackXI] = useState('transparent');

  const ChangeAnchor = (key) => {
    console.log(key);
    if (key === '#1') {
      setBackI(appColors['ColorC']);
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
      setBackV('transparent');
      setBackVI('transparent');
      setBackVII('transparent');
      setBackVIII('transparent');
      setBackIX('transparent');
      setBackX('transparent');
      setBackXI('transparent');
    } else if (key == '#2') {
      setBackI('transparent');
      setBackII(appColors['ColorC']);
      setBackIII('transparent');
      setBackIV('transparent');
      setBackV('transparent');
      setBackVI('transparent');
      setBackVII('transparent');
      setBackVIII('transparent');
      setBackIX('transparent');
      setBackX('transparent');
      setBackXI('transparent');
    } else if (key == '#3') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII(appColors['ColorC']);
      setBackIV('transparent');
      setBackV('transparent');
      setBackVI('transparent');
      setBackVII('transparent');
      setBackVIII('transparent');
      setBackIX('transparent');
      setBackX('transparent');
      setBackXI('transparent');
    } else if (key == '#4') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV(appColors['ColorC']);
      setBackV('transparent');
      setBackVI('transparent');
      setBackVII('transparent');
      setBackVIII('transparent');
      setBackIX('transparent');
      setBackX('transparent');
      setBackXI('transparent');
    } else if (key == '#5') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
      setBackV(appColors['ColorC']);
      setBackVI('transparent');
      setBackVII('transparent');
      setBackVIII('transparent');
      setBackIX('transparent');
      setBackX('transparent');
      setBackXI('transparent');
    } else if (key == '#6') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
      setBackV('transparent');
      setBackVI(appColors['ColorC']);
      setBackVII('transparent');
      setBackVIII('transparent');
      setBackIX('transparent');
      setBackX('transparent');
      setBackXI('transparent');
    } else if (key == '#7') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
      setBackV('transparent');
      setBackVI('transparent');
      setBackVII(appColors['ColorC']);
      setBackVIII('transparent');
      setBackIX('transparent');
      setBackX('transparent');
      setBackXI('transparent');
    } else if (key == '#8') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
      setBackV('transparent');
      setBackVI('transparent');
      setBackVII('transparent');
      setBackVIII(appColors['ColorC']);
      setBackIX('transparent');
      setBackX('transparent');
      setBackXI('transparent');
    } else if (key == '#9') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
      setBackV('transparent');
      setBackVI('transparent');
      setBackVII('transparent');
      setBackVIII('transparent');
      setBackIX(appColors['ColorC']);
      setBackX('transparent');
      setBackXI('transparent');
    } else if (key == '#10') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
      setBackV('transparent');
      setBackVI('transparent');
      setBackVII('transparent');
      setBackVIII('transparent');
      setBackIX('transparent');
      setBackX(appColors['ColorC']);
      setBackXI('transparent');
    } else if (key == '#11') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
      setBackV('transparent');
      setBackVI('transparent');
      setBackVII('transparent');
      setBackVIII('transparent');
      setBackIX('transparent');
      setBackX('transparent');
      setBackXI(appColors['ColorC']);
    }
  };
  return (
    <Layout style={{background: 'transparent'}}>
      <Sider style={{background: 'transparent'}}>
        <Anchor onClick={handleClick} offsetTop={75} onChange={ChangeAnchor} style={{background: 'transparent'}}>
          <Link href='#1' title={<Content className='ContentAnchor' style={{borderColor: backI}}><Text style={{color: appColors['ColorC'], fontSize: '2.2vh'}}>State of the art</Text></Content>}/>
          <Link href='#2' title={<Content className='ContentAnchor' style={{borderColor: backII}}><Text style={{color: appColors['ColorC'], fontSize: '2vh'}}>Product and service</Text></Content>}/>
          <Link href='#3' title={<Content className='ContentAnchor' style={{borderColor: backIII}}><Text style={{color: appColors['ColorC'], fontSize: '1.8vh'}}>Company Description</Text></Content>}/>
          <Link href='#4' title={<Content className='ContentAnchor' style={{borderColor: backIV}}><Text style={{color: appColors['ColorC'], fontSize: '1.6vh'}}>Organizational Structure</Text></Content>}/>
          <Link href='#5' title={<Content className='ContentAnchor' style={{borderColor: backV}}><Text style={{color: appColors['ColorC'], fontSize: '3vh'}}>Key Factors</Text></Content>}/>
          <Link href='#6' title={<Content className='ContentAnchor' style={{borderColor: backVI}}><Text style={{color: appColors['ColorC'], fontSize: '2.3vh'}}>Value proposition</Text></Content>}/>
          <Link href='#7' title={<Content className='ContentAnchor' style={{borderColor: backVII}}><Text style={{color: appColors['ColorC'], fontSize: '2.7vh'}}>Business Model</Text></Content>}/>
          <Link href='#8' title={<Content className='ContentAnchor' style={{borderColor: backVIII}}><Text style={{color: appColors['ColorC'], fontSize: '3vh'}}>SWOT</Text></Content>}/>
          <Link href='#9' title={<Content className='ContentAnchor' style={{borderColor: backIX}}><Text style={{color: appColors['ColorC'], fontSize: '3vh'}}>Pestle</Text></Content>}/>
          <Link href='#10' title={<Content className='ContentAnchor' style={{borderColor: backX}}><Text style={{color: appColors['ColorC'], fontSize: '3vh'}}>Validation</Text></Content>}/>
          <Link href='#11' title={<Content className='ContentAnchor' style={{borderColor: backXI}}><Text style={{color: appColors['ColorC'], fontSize: '3vh'}}>References</Text></Content>}/>
        </Anchor>
      </Sider>
      <Layout style={{margin: '1% 1% 0 1%', width: 'fit-content'}}>
        <Layout style={{background: appColors['ColorX'], height: '1px'}} />
        <Layout className='PurpBack' style={{background: appColors['ColorG']}}>
          <Layout style={{margin: '0 0 0 0', background: 'transparent'}}>
            <div id='1'>
              <Uno/>
            </div>
            <div id='2'>
              <Dos/>
            </div>
            <div id='3'>
              <Tres/>
            </div>
            <div id='4'>
              <Cuatro/>
            </div>
            <div id='5'>
              <Cinco/>
            </div>
            <div id='6'>
              <Seis/>
            </div>
            <div id='7'>
              <Siete/>
            </div>
            <div id='8'>
              <Ocho/>
            </div>
            <div id='9'>
              <Nueve/>
            </div>
            <div id='10'>
              <Diez/>
            </div>
            <div id='11'>
              <References/>
            </div>
          </Layout>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default EntrepreneurshipBM;
